import type { PageConfig } from '~/types/page-config'
import { getPageConfig } from '~/utils/page-config'
import { relative } from '~/utils/path'
export const usePageConfig = (): PageConfig => {
  const { environment, host, path } = usePageEnvironment()
  const config = getPageConfig(environment, host, path)

  if (config === undefined) {
    throw new Error(`No page config matched the current request. Environment: ${environment}, Host: ${host}, Path: ${path}`)
  }

  return {
    relativePath: config.path ? '/' + relative(config.path, path) : path,
    etUrl: config.etUrl,
    storyblok: {
      ...config.storyblok,
    },
    errorPage: config.errorPage,
  }
}
